<template>
  <div class="the-footer flex-wrap" :class="{'footer-collapsed': isVerticalMenuCollapsed}">
    <div class="footer-block">
      <div class="footer-content">
        
        <div
          class="footer-content-logo-cma"
          :class="{ 'footer-content-logo-cma-min': !canDisplayItens }"
        >
          <div class="footer-power" v-if="canDisplayItens">
            Powered by
          </div>
          <span
            class="logo-cma-pwd cursor-pointer"
            @click="$emit('open-help')"
          ></span>
          <span class="line" v-if="canDisplayItens"></span>
        </div>
        <!-- <b-button
          variant="flat-primary"
          class="btn-sm btn-nav-link btn-nav-link-white btn-footer"
          v-if="canDisplayItens"
          @click="$emit('open-help')"
        >
          <feather-icon icon="HelpCircleIcon" />
          Ajuda
        </b-button> -->
        <b-link
          v-if="canDisplayItens"
          size="sm"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          @click="$emit('open-attendance')"
          class="btn-sm btn-nav-link btn-nav-link-white lk-help"
        >
          <feather-icon icon="HelpCircleIcon" class="mr-50" />
          <span class="align-middle">{{$t('BUTTONS.Help')}}</span>
        </b-link>
      </div>

      <div class="copy-footer" v-if="canDisplayItens">
        COPYRIGHT @ {{ new Date().getFullYear() }} -
        <a href="https://www.safras.com.br" target="_blank" rel="nofollow">Safras e Mercados</a>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { BLink } from "bootstrap-vue";
import { inject } from "@vue/composition-api";
export default {
  props: {},
  directives: {
    Ripple,
  },
  components: {
    BLink,
  },
  computed: {
    isVerticalMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },
    canDisplayItens() {
      return !this.isVerticalMenuCollapsed || this.isMouseHovered;
    },
  },
  methods: {
    displayHelp() {
      console.log("display help");
    },
  },
  setup() {
    const isMouseHovered = inject("isMouseHovered");
    return {
      isMouseHovered,
    };
  },
};
</script>

<style lang="scss"></style>
